module.exports = __webpack_public_path__ + "media/partners.mp4";